import { Pagination } from './commonTypes';

export enum DriverTaskType {
  PICKUP_BROKEN = 'PICKUP_BROKEN',
  PICKUP_OFFLINE = 'PICKUP_OFFLINE',
  PICKUP_LOW_BATTERY = 'PICKUP_LOW_BATTERY',
  PICKUP_BAD_PARKING = 'PICKUP_BAD_PARKING',
  RELOCATE = 'RELOCATE',
  PICKUP_IDLE = 'PICKUP_IDLE',
}

export enum DriverTaskStatus {
  PENDING = 'PENDING',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  CANCELED = 'CANCELED',
}

export enum DriverTaskPriority {
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  HIGH = 'HIGH',
  URGENT = 'URGENT',
}

export interface DriverTaskScooter {
  _id: string;
  name: string;
  flespiTypeId: string;
  coords: {
    lat: number;
    lon: number;
    updatedAt?: string;
  };
  battery: number;
}

export interface DriverTaskAssignee {
  _id: string;
  login: string;
  firstName: string;
  lastName: string;
}

export interface DriverTaskDestination {
  lat: number;
  lon: number;
  address?: string;
}

export interface DriverTask {
  _id: string;
  type: DriverTaskType;
  status: DriverTaskStatus;
  priority: DriverTaskPriority;
  scooter: DriverTaskScooter | string;
  description?: string;
  assignedTo?: DriverTaskAssignee | string;
  assignedToLogin?: string;
  destination?: DriverTaskDestination;
  city: string;
  photos: string[];
  note?: string;
  startedAt?: string;
  completedAt?: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateDriverTaskBody {
  type: DriverTaskType;
  scooterId: string;
  priority?: DriverTaskPriority;
  description?: string;
  assignedTo?: string;
  destination?: DriverTaskDestination;
}

export interface CreateBulkDriverTasksBody {
  type: DriverTaskType;
  scooterIds: string[];
  priority?: DriverTaskPriority;
  description?: string;
  assignedTo?: string;
  destination?: DriverTaskDestination;
}

export interface UpdateDriverTaskBody {
  priority?: DriverTaskPriority;
  description?: string;
  assignedTo?: string;
  destination?: DriverTaskDestination;
}

export interface FinishDriverTaskBody {
  photos?: string[];
  note?: string;
}

export interface CancelDriverTaskBody {
  reason?: string;
}

export interface GetDriverTasksParams {
  status?: DriverTaskStatus;
  type?: DriverTaskType;
  priority?: DriverTaskPriority;
  assignedTo?: string;
  scooterName?: string;
  dateFrom?: string;
  dateTo?: string;
  page?: number;
  limit?: number;
}

export interface GetDriverTasksResponse {
  data: DriverTask[];
  pagination: Pagination;
}

export interface DriverTaskStats {
  pending: number;
  inProgress: number;
  completedToday: number;
  urgent: number;
}

export interface GetDriverTaskStatsResponse {
  data: DriverTaskStats;
}

export interface BulkCreateResponse {
  created: number;
  tasks: DriverTask[];
}
